module.exports = __webpack_public_path__ + "img/n_rule_2023.2fe08eb8.png";